import Vue from 'vue'

import i18n from '@plugin/i18n'

import ElementUI from 'element-ui'

import ZhiLinkUI from 'element-ui/lib/element-ui.extend.js'

Vue.use(ElementUI, {
  size: 'small', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

Vue.use(ZhiLinkUI, {
  size: 'small', // set zhiLink-ui default size
  i18n: (key, value) => i18n.t(key, value)
})
